<template>
  <ul id="nav-mobile" class="sidenav sidenav-fixed">
    <li>
      <div class="user-view hubday-bg-dark">
        <a>
          <img class="circle" :src="userProfile.photoURL" />
        </a>
        <a>
          <span class="white-text name">
            {{ userProfile.displayName }}
            <span
            v-if="userProfile.group1 != ''"
              class="new badge"
              :data-badge-caption="userProfile.group1 + (userProfile.subgroup1 == 'prime' ? '\'' : (userProfile.subgroup1 == 'seconde' ? '\'\'' : ''))"
            ></span>
            <span
            v-if="userProfile.group2 != ''"
              class="new badge red"
              :data-badge-caption="userProfile.group2 + (userProfile.subgroup2 == 'prime' ? '\'' : (userProfile.subgroup2 == 'seconde' ? '\'\'' : ''))"
            ></span>
          </span>
        </a>
        <a>
          <span class="white-text email">{{ (userProfile.permissions.includes("guest") ? "" : userProfile.email) }}</span>
        </a>
      </div>
    </li>
    <li>
      <router-link :to="{ path: '/dashboard' }">
        <i class="material-icons-outlined">home</i>Vue d'ensemble
      </router-link>
    </li>
    <li>
      <router-link :to="{ path: '/planning' }">
        <i class="material-icons-outlined">view_day</i>Emploi du temps
      </router-link>
    </li>
    <li>
      <router-link :to="{ path: '/agenda' }">
        <i class="material-icons-outlined">book</i>Agenda
      </router-link>
    </li>
    <li>
      <router-link :to="{ path: '/events' }">
        <i class="material-icons-outlined">calendar_today</i>Événements
      </router-link>
    </li>
    <li>
      <div class="divider"></div>
    </li>
    <li>
      <router-link :to="{ path: '/modules' }">
        <i class="material-icons-outlined">school</i>Matières
      </router-link>
    </li>
    <li>
      <router-link :to="{ path: '/professors' }">
        <i class="material-icons-outlined">emoji_people</i>Professeurs
      </router-link>
    </li>
    <li>
      <router-link :to="{ path: '/rooms' }">
        <i class="material-icons-outlined">meeting_room</i>Salles
      </router-link>
    </li>
    <li>
      <div class="divider"></div>
    </li>
    <li>
      <router-link :to="{ path: '/help' }">
        <i class="material-icons-outlined">help_outline</i>Aides et commentaires
      </router-link>
    </li>
    <li>
      <router-link :to="{ path: '/settings' }">
        <i class="material-icons-outlined">settings</i>Paramètres
      </router-link>
    </li>
    <li id="logout">
      <a @click="logout()">
        <i class="material-icons-outlined">login</i>Déconnexion
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";
import M from "materialize-css";

export default {
  mounted() {
    var elem = document.querySelector(".sidenav");
    var instance = M.Sidenav.init(elem);
  },
  methods: {
    logout() {
      this.hideSideNav();
      this.$store.dispatch("logout");
    },
    hideSideNav() {
      var elem = document.querySelector(".sidenav");
      var instance = M.Sidenav.init(elem);
      instance.close();
    }
  },
  computed: {
    ...mapState(["userProfile"]),
  },
  watch: {
    $route(to, from) {
      this.hideSideNav();
    },
  },
};
</script>
